import React from 'react';

interface ShowChatInterface {
    showChat: boolean;
    setShowChat: any;
}
  
export const ShowChatCtx = React.createContext<ShowChatInterface | null>(null);
